import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'none',
    cursor: 'pointer',
    border: 0
  },
  actionNeededChip: {
    color: '#FF004E',
    backgroundColor: '#FFD4E7',
    fontWeight: 600,
    padding: theme.spacing(0.05),

    '&:hover': {
      backgroundColor: '#FFD4E7',
    }
  }
}));

export default function ClaimDisposition({ disposition, hasLabel, textVariant }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const DispositionLabel = hasLabel && (
    <Typography variant="body2" color="textSecondary">
      {t('disposition')}
    </Typography>
  )

  const DispositionMarkup = disposition?.toLowerCase() === 'action needed'
    ? (
      <Chip
        clickable
        className={classes.actionNeededChip}
        label={t('actionNeeded')}
      />
    )
    : (
      <>
        <Typography noWrap variant={textVariant} color="textPrimary">
          {disposition || 'N/A'}
        </Typography>
        {DispositionLabel}
      </>
    );

  return (
    <button id="disposition-button" type="button" className={classes.root}>
      {DispositionMarkup}
    </button>
  )
}

ClaimDisposition.displayName = 'ClaimDisposition';

ClaimDisposition.propTypes = {
  /**
   * The claim disposition.
   */
  disposition: PropTypes.string,
  /** 
   * Whether this component should apply a label below 
   * the disposition value 
  */
  hasLabel: PropTypes.bool,
  /** 
   * Applied to the disposition value when the disposition
   * value is something other than 'Action Needed'
  */
  textVariant: PropTypes.oneOf([
    'h1'
    , 'h2'
    , 'h3'
    , 'h4'
    , 'h5'
    , 'h6'
    , 'subtitle1'
    , 'subtitle2'
    , 'body1'
    , 'body2'
    , 'caption'
    , 'button'
    , 'overline'
    , 'srOnly'
    , 'inherit'
  ])
};

ClaimDisposition.defaultProps = {
  hasLabel: true,
  textVariant: 'h6'
};
